import { useCallback, useState } from 'react';

import { captureException } from '@sentry/nextjs';
import axios from 'axios';
import EnquiryTypes from 'constants/EnquiryTypes';

import { useRecaptcha } from 'contexts/recaptchaContext';

import QuestionForm, {
  QuestionFormData,
  QuestionFormProps,
} from '../QuestionForm/QuestionForm';
interface QuestionFormContainerProps
  extends Omit<QuestionFormProps, 'onSubmit'> {
  onSubmit(value: QuestionFormData | undefined): any;
  vehicleVin?: string;
}

const QuestionFormContainer = ({
  onSubmit: propsOnSubmit,
  vehicleVin,
  ...props
}: QuestionFormContainerProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { verifyRecaptcha } = useRecaptcha();

  const onSubmit = useCallback(
    async ({
      car_looking_for,
      car_month_enquiry,
      ...data
    }: QuestionFormData) => {
      try {
        setLoading(true);

        const recaptchaVerified = await verifyRecaptcha();

        if (!recaptchaVerified) {
          console.error('Recaptcha Failed');
          return;
        }

        const formData = {
          ...data,
          state: data.state.name,
        };
        if (data.enquiry_type === EnquiryTypes.LookingForASpecificCar) {
          formData.message = [
            data.message,
            car_looking_for,
            car_month_enquiry,
          ].join('\n');
        }
        if (data.enquiry_type === EnquiryTypes.VehicleEnquiry) {
          formData.message = [`${data.message} /vehicles/${vehicleVin}`].join(
            '\n',
          );
        }

        const response = await axios.post('/api/customer-enquiry', {
          formData,
        });

        setLoading(false);
        propsOnSubmit(response.data);
      } catch (error: any) {
        propsOnSubmit(undefined);
        return captureException(Error(`[Client-Side]: ${error?.toString()}`));
      }
    },
    [propsOnSubmit, verifyRecaptcha, vehicleVin],
  );

  return <QuestionForm onSubmit={onSubmit} loading={loading} {...props} />;
};

export default QuestionFormContainer;
